import { Button } from 'antd';

import type IPagination from 'interfaces/IPagination';
import { sendEventToGA } from 'v2/helpers/analytics';
import { financialStatementBlockedService } from 'v2/services/financialStatement/blocked';
import { financialStatementService } from 'v2/services/financialStatement/statement';

type Props = {
  isLoading?: boolean;
  pagination: IPagination;
  showBlockedDetails: boolean;
};

function PaginationLoadMore({ isLoading = false, pagination, showBlockedDetails }: Props) {
  const loadMore = () => {
    sendEventToGA({
      category: 'Novo Extrato',
      action: 'Botão',
      label: 'Mostrar mais itens'
    });

    const newPagination = {
      ...pagination,
      current_page: pagination.current_page + 1
    };

    if (showBlockedDetails) {
      financialStatementBlockedService.getNextPageDetails(newPagination);
    } else {
      financialStatementService.getNextPageDetails(newPagination);
    }
  };

  const isLastPage = pagination?.current_page === pagination?.total_pages;

  if (isLastPage || isLoading) {
    return null;
  }

  return (
    <div className='my-6'>
      <Button size='small' type='default' onClick={loadMore}>
        Mostrar mais itens
      </Button>
    </div>
  );
}

export default PaginationLoadMore;
